<div *ngIf="isLoading">
  <app-loader></app-loader>
</div>
<div class="container mx-auto px-4 md:px-8 py-12 mt-16 max-w-4xl">
  <div class="text-center mb-12 sm:mb-16 relative">
    <h2 class="text-2xl sm:text-3xl font-extrabold text-gray-800">Suppliers</h2>
    <div
      class="w-16 sm:w-20 h-1 bg-gradient-to-r from-[#F9CC0B] to-[#FFE97F] mx-auto mt-2 rounded-full"
    ></div>
    <img
      src="assets/images/supplier.jpg"
      alt="Supplier"
      class="mx-auto mt-4 w-full max-h-[60vh] object-cover rounded-xl"
    />
  </div>

  <div
    class="terms-content text-gray-700 leading-relaxed text-justify supplier"
    [innerHTML]="supplierContent"
  ></div>
</div>
